import React from 'react';

const Footer = () => (
  <footer className="w-full bg-gray-900 text-gray-200 border-t border-gray-800 mt-10">
    <div className="max-w-7xl mx-auto px-4 pt-8 pb-12 flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0">
      <div className="flex items-center gap-3">
        <img src={process.env.PUBLIC_URL + '/Logo.png'} alt="Logo" className="h-8 w-8 rounded shadow" />
        <span className="font-bold text-lg tracking-wide">GreenSchool WorkSpace</span>
      </div>
      <nav className="flex flex-wrap gap-6 text-sm font-medium">
        <a href="/dashboard" className="hover:text-emerald-400 transition">Tổng quan</a>
        <a href="/calendar" className="hover:text-emerald-400 transition">Lịch</a>
        <a href="/teams" className="hover:text-emerald-400 transition">Phòng ban</a>
        <a href="/reports" className="hover:text-emerald-400 transition">Báo cáo</a>
        <a href="/settings" className="hover:text-emerald-400 transition">Cài đặt</a>
      </nav>
      <div className="flex flex-col md:items-end items-center gap-1">
        <span className="text-xs">© {new Date().getFullYear()} GreenSchool WorkSpace. All rights reserved.</span>
        <span className="text-xs flex items-center gap-1">
          Build by
          <a href="https://www.linkedin.com/in/danducvu" target="_blank" rel="noopener noreferrer" className="text-emerald-400 hover:underline font-semibold">danducvu</a>
          <svg className="w-4 h-4 ml-1 text-emerald-400" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.761 0 5-2.239 5-5v-14c0-2.761-2.239-5-5-5zm-11 19h-3v-9h3v9zm-1.5-10.268c-.966 0-1.75-.784-1.75-1.75s.784-1.75 1.75-1.75 1.75.784 1.75 1.75-.784 1.75-1.75 1.75zm15.5 10.268h-3v-4.604c0-1.099-.021-2.513-1.532-2.513-1.532 0-1.767 1.197-1.767 2.434v4.683h-3v-9h2.881v1.229h.041c.401-.761 1.379-1.563 2.841-1.563 3.04 0 3.601 2.002 3.601 4.604v4.73z"/></svg>
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
